import { baseApi } from "../../api/baseApi";

const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (userInfo) => ({
        url: "/account/login/",
        method: "POST",
        body: userInfo,
      }),
    }),
    registration: builder.mutation({
      query: (user) => ({
        url: "/account/register/",
        method: "POST",
        body: user,
      }),
    }),
    resendVerification: builder.mutation({
      query: (data) => ({
        url: "/account/resend-verification/",
        method: "POST",
        body: data,
      }),
    }),
    profile: builder.query({
      query: () => ({
        url: "/account/profile/",
        method: "GET",
      }),
      providesTags: ["profile"],
    }),
    forgetPasswordRequest: builder.mutation({
      query: (data) => ({
        url: "/account/password-reset-request/",
        method: "POST",
        body: data,
      }),
    }),
    forgetPasswordConfirm: builder.mutation({
      query: ({ password, token }) => ({
        url: `/account/password-reset-confirm/`,
        method: "POST",
        body: {
          password,
          token,  // ✅ CHANGED: Token now in request body instead of Authorization header
        },
        // ✅ REMOVED: Authorization header (token is now in body)
      }),
    }),
    // Invitation link (new staff / partner owner): who it's for, then set the first password.
    peekInvite: builder.query({
      query: (token) => ({ url: `/account/accept-invite/?token=${encodeURIComponent(token)}`, method: "GET" }),
    }),
    acceptInvite: builder.mutation({
      query: (data) => ({ url: "/account/accept-invite/", method: "POST", body: data }),
    }),
    // Logged-in user replaces their own password (e.g. an emailed temporary one).
    changePassword: builder.mutation({
      query: (data) => ({
        url: "/account/change-password/",
        method: "POST",
        body: data,
      }),
    }),
    


  }),
});

export const {
  useLoginMutation,
  useRegistrationMutation,
  useResendVerificationMutation,
  useProfileQuery,
  useForgetPasswordRequestMutation,
  useForgetPasswordConfirmMutation,
  useChangePasswordMutation,
  usePeekInviteQuery,
  useAcceptInviteMutation,
} = authApi;
